import React from "react";
import Container from "reactstrap/lib/Container";
import BenefitsHTML from "../Components/BenefitsHTML";
import Block from "ComponentsUI/Block";
import outhomeText from "Texts/outhome";
import { observer, inject } from "mobx-react";

@inject("ApplicationModel")
@observer
export default class BlockText extends React.Component {
	render() {
		let text = this.props.ApplicationModel.text;

		return (
			<Block header={text.OUTHOME_BLOCK_HEADER}>
				<Container>
					<BenefitsHTML text={outhomeText} />
				</Container>
			</Block>
		);
	}
}
